<template>
  <div>
    <ion-list v-model="valid">
      <ion-list-header>
        <ion-label>{{ $t("bookings.driverData") }}</ion-label>
      </ion-list-header>
      <ion-item :class="{ 'has-error': v$.form.client_name.$error }">
        <ion-label position="floating">
          {{ $t("bookings.fullName") }}
        </ion-label>
        <ion-input autocomplete="name" v-model="v$.form.client_name.$model"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating"> {{ $t("bookings.idDoc") }} </ion-label>
        <ion-input autocomplete="iddoc" v-model="v$.form.client_id_doc.$model"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating"> {{ $t("bookings.clientAddress") }} </ion-label>
        <ion-input autocomplete="client_address" v-model="v$.form.client_address.$model"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating"> {{ $t("bookings.email") }} </ion-label>
        <ion-input
          type="email"
          name="email"
          v-model="v$.form.client_email.$model"
        ></ion-input>
      </ion-item>
      <div class="input-tel-container">
        <country-select class="country-select-con" v-model="v$.form.client_country.$model"></country-select>
      <ion-item class="tel-container">
        <ion-label position="floating"> {{ $t("bookings.phone") }} </ion-label>
        <ion-input name="phone" autocomplete="tel" type="tel" v-model="v$.form.client_phone.$model"></ion-input>
      </ion-item>
      </div>
      
      
      <ion-item>
        <ion-label style="white-space: break-spaces;">
          {{ $t("bookings.disclaimer1") }}
        </ion-label>
        <ion-checkbox slot="start" v-model="v$.form.disclaimer1.$model"></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label style="white-space: break-spaces;">
          {{ $t("bookings.disclaimer2", {amount: price.depositPrice}) }}
        </ion-label>
        <ion-checkbox slot="start" v-model="v$.form.disclaimer2.$model"></ion-checkbox>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import FileUploaderComponent from "../FileUploaderComponent";
import CountrySelect from "../CountrySelect";
import { defineComponent } from "vue";
import { IonList, IonItem, IonLabel, IonInput, IonCheckbox } from "@ionic/vue";
import useVuelidate from "@vuelidate/core";
import { required, email, sameAs } from "@vuelidate/validators";
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

export default defineComponent({
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
    price: {
      required: false,
      type: Object,
    },
  },
  components: {
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    IonCheckbox,
    CountrySelect,
    // IonCheckbox,
  },
  data: () => ({
    valid: false,
    countries: [],
    form: {
      client_name: null,
      client_id_doc: null,
      client_email: null,
      client_phone: null,
      client_address: null,
      client_country: null,
      disclaimer1: false,
      disclaimer2: false,
      media_ids: [],
    },
  }),
  validations() {
    return {
      form: {
        client_name: { required },
        client_id_doc: { required },
        client_email: { required, email },
        client_address: { required },
        client_phone: { required },
        client_country: { required },
        disclaimer1: { sameAs: sameAs(true) },
        disclaimer2: { sameAs: sameAs(true) },
      },
    };
  },
  mounted() {
    this.getCountries();
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
        this.$emit("valid", 7, !this.v$.$invalid);
      },
    },
  },
  methods: {
    getCountries() {
      axios.get("/countries").then((resp) => {
        this.countries = resp.data;
      });
    },
  },
});
</script>

<style lang="scss">
.v-text-field__details {
  display: none;
}
.error--text .v-text-field__details {
  display: inline;
}
.filepond--wrapper {
  margin: 10px;
}
.input-tel-container {
  position: relative;
  .tel-container {
    margin-left: 40px;
  }
  .country-select-con {
    padding: 22px 11px;
    border-bottom: 1px solid #dedede;
    display: inline;
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: center;
    position: absolute;
  }
}
</style>
